import React from 'react';
import { NavLink } from 'react-router-dom';
import { useMediaQuery } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import PaymentIcon from '@material-ui/icons/Payment';

import Header from '../../../components/Header';
import { Sidebar, SafeArea, useStyles } from './AdminLayoutStyles';

export default function AdminLayout({ children }: { children: any }) {
  const classes = useStyles();
  const isDesktop = useMediaQuery('(min-width:850px)');

  return (
    <>
      <Header />
      {isDesktop && (
        <Sidebar className={classes.sidebar}>
          <NavLink
            to="/admin"
            exact
            className={classes.navLink}
            activeClassName={classes.activeLink}
          >
            <DashboardIcon />
            Dashboard
          </NavLink>
          <NavLink
            to="/admin/users"
            className={classes.navLink}
            activeClassName={classes.activeLink}
          >
            <PeopleIcon />
            Usuarios
          </NavLink>
          <NavLink
            to="/admin/payments"
            className={classes.navLink}
            activeClassName={classes.activeLink}
          >
            <PaymentIcon />
            Pagamentos
          </NavLink>
        </Sidebar>
      )}
      <SafeArea container>{children}</SafeArea>
    </>
  );
}
